import { render, staticRenderFns } from "./ConferenciaResumoTotal.vue?vue&type=template&id=38c4c210&scoped=true"
import script from "./ConferenciaResumoTotal.vue?vue&type=script&lang=js"
export * from "./ConferenciaResumoTotal.vue?vue&type=script&lang=js"
import style0 from "./ConferenciaResumoTotal.vue?vue&type=style&index=0&id=38c4c210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4c210",
  null
  
)

export default component.exports